var React = require('react');

function IconExcel (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1D1E22","fillRule":"evenodd","d":"M12.88 7.9V.56H2.06c-.72 0-1.3.58-1.3 1.3v25.1c0 .71.58 1.29 1.3 1.29h18.17c.72 0 1.3-.58 1.3-1.3V9.2h-7.35a1.3 1.3 0 01-1.3-1.3zm3.25 5.77l-3.25 5.05 3.25 5.06c.27.43-.03 1-.55 1H13.7a.65.65 0 01-.57-.34 283.64 283.64 0 01-1.97-3.72c-.25.57-.42.87-1 1.93l-.98 1.8a.64.64 0 01-.57.33H6.71a.65.65 0 01-.54-1l3.26-5.05-3.26-5.06a.65.65 0 01.54-1H8.6c.23 0 .45.13.57.34.6 1.14.9 1.63 1.1 1.98.25.46.37.65.88 1.73 0 0 .33-.64 1.98-3.7a.65.65 0 01.57-.35h1.88c.52 0 .82.56.55 1zm5.4-6.2v-.33c0-.34-.14-.67-.38-.9l-5.3-5.3a1.3 1.3 0 00-.91-.39h-.33v6.92h6.92z","clipRule":"evenodd"}));
}

IconExcel.defaultProps = {"width":"35","height":"46","fill":"none","viewBox":"0 0 22 29"};

module.exports = IconExcel;

IconExcel.default = IconExcel;
